import RequestApi from "../../utils/request";

export default {
	//获取导航数据
	GetNavData:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Platform/GetNavData/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//全站搜索
	AllSearch:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Platform/AllSearch/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	
}